export default {
    /**接口请求的基础路径 */
    baseUrl: {
      dev: 'https://www.fangxiaodou.com/fxd-api',
      pro: 'https://www.fangxiaodou.com/fxd-api' // 生产路径
    },
  };


